//@ts-nocheck
import { OrderedSet } from "immutable";
import React from "react";
import styled from "styled-components";

import { eventEmitter, autoComplete } from "../../../services";
import {
    AUTOCOMPLETE_HIDE,
    AUTOCOMPLETE_NEXT,
    AUTOCOMPLETE_PREV,
    AUTOCOMPLETE_SELECT,
    AUTOCOMPLETE_SHOW,
} from "./AutoCompleteService";
import { getPosition, Position } from "./helpers";

const OFFSET_TOP = 32;

interface ContainerProps extends Position {
    count: number;
    enableDarkTheme: boolean;
}
const Container = styled.div`
    display: ${(p: ContainerProps) => (p.count > 0 ? "block" : "none")};
    position: absolute;
    padding: 3px 0;
    right: ${(p: ContainerProps) => window.innerWidth - p.left}px;
    top: ${(p: ContainerProps) => p.top + OFFSET_TOP}px;
    display: flex;
    border-radius: 4px;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    color: ${(p: ContainerProps) => (p.enableDarkTheme ? "#000" : "#fff")};
    background-color: ${(p: ContainerProps) =>
        p.enableDarkTheme ? "#fff" : "#000"};
`;

interface ItemProps {
    selected: boolean;
    enableDarkTheme: boolean;
}
const Item = styled.div`
    cursor: pointer;
    user-select: none;
    padding: 3px 15px;
    width: 100%;
    min-width: 150px;
    color: ${(p: ItemProps) => (p.enableDarkTheme ? "#000" : "#f5f5f5")};
    border-bottom: 1px solid
        ${(p: ItemProps) => (p.enableDarkTheme ? "#f5f5f5" : "#353839")};
    white-space: nowrap;

    &:last-child {
        border-bottom: 0;
    }

    background-color: ${(p: ItemProps) => {
        if (p.selected) {
            return p.enableDarkTheme ? "#f5f5f5" : "#353839";
        }

        return "transparent";
    }};
`;

interface Props {
    enableDarkTheme: boolean;
}
interface State {
    list: ReturnType<typeof OrderedSet>;
    selected: number;
}
export class AutoComplete extends React.Component<Props, State> {
    state = {
        list: OrderedSet<string>(),
        selected: -1,
    };

    componentDidMount() {
        eventEmitter.on(AUTOCOMPLETE_SHOW, this.onShow);
        eventEmitter.on(AUTOCOMPLETE_HIDE, this.onHide);
        eventEmitter.on(AUTOCOMPLETE_PREV, this.onPrev);
        eventEmitter.on(AUTOCOMPLETE_NEXT, this.onNext);
        eventEmitter.on(AUTOCOMPLETE_SELECT, this.onSelect);
    }

    componentWillUnmount() {
        eventEmitter.off(AUTOCOMPLETE_SHOW, this.onShow);
        eventEmitter.off(AUTOCOMPLETE_HIDE, this.onHide);
        eventEmitter.off(AUTOCOMPLETE_PREV, this.onPrev);
        eventEmitter.off(AUTOCOMPLETE_NEXT, this.onNext);
        eventEmitter.off(AUTOCOMPLETE_SELECT, this.onSelect);
    }

    onShow = (list: OrderedSet<string>) => this.setState({ list, selected: 0 });
    onHide = () => this.setState({ list: this.state.list.clear() });

    onPrev = () => {
        const { selected, list } = this.state;
        this.setState({
            selected: selected === 0 ? list.count() - 1 : selected - 1,
        });
    };

    onNext = () => {
        const { selected, list } = this.state;
        this.setState({
            selected: (selected + 1) % list.count(),
        });
    };

    onSelect = () => {
        const { list, selected } = this.state;
        this.sendValue(list.toJS()[selected]);
    };

    sendValue = (word: string) => autoComplete.replaceValue(word);

    render() {
        if (this.state.list.count() === 0) {
            return null;
        }

        const { list, selected } = this.state;
        const { enableDarkTheme } = this.props;

        return (
            <Container
                count={list.count()}
                enableDarkTheme={enableDarkTheme}
                {...getPosition()}
            >
                {list.toJS().map((value: string, i: number) => (
                    <Item
                        key={`ac-${i}`}
                        selected={i === selected}
                        enableDarkTheme={enableDarkTheme}
                        onClick={() => this.sendValue(value)}
                    >
                        {value}
                    </Item>
                ))}
            </Container>
        );
    }
}
